import React, { useState } from 'react';
import GPAIStats from './GPAIStats';
import DAIStats from './DAIStats';

const palette = {
  main: '#475569',
  hover: '#cbd5e1',
  light: '#f8fafc',
  dark: '#23244A',
  border: '#e0e7ef',
  selected: '#020742',
  brand: '#0097B2',
};

const tabStyles = {
  container: {
    width: '100%',
    background: '#fff',
    borderRadius: '18px',
    boxShadow: '0 4px 16px rgba(2,7,66,0.07)',
    padding: 0,
    margin: '24px auto 0 auto',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column' as const,
    flex: 1,
    maxWidth: '1200px',
    border: '1.5px solid #e0e7ef',
  },
  navbar: {
    display: 'flex',
    borderBottom: '2px solid #e0e7ef',
    background: '#f8fafc',
    borderRadius: '18px 18px 0 0',
    marginBottom: 0,
    padding: 0,
    minHeight: 0,
    boxShadow: '0 2px 8px rgba(2,7,66,0.04)',
  },
  button: (active: boolean) => ({
    flex: 1,
    padding: '16px 0',
    border: 'none',
    borderBottom: active ? `3px solid ${palette.brand}` : '3px solid transparent',
    color: active ? palette.brand : palette.main,
    fontWeight: active ? 700 : 500,
    fontSize: '1.08rem',
    cursor: 'pointer',
    outline: 'none',
    borderRadius: '18px 18px 0 0',
    minWidth: 0,
    background: 'none',
    transition:
      'color 0.18s, border-bottom 0.18s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: 'none',
    letterSpacing: '0.01em',
  }),
  buttonHover: {
    background: '#f8fafc',
    color: palette.brand,
  },
  content: {
    flex: 1,
    padding: 0,
    minHeight: 0,
    background: '#fff',
    borderRadius: '0 0 18px 18px',
    maxWidth: '100%',
    overflow: 'auto',
  },
};

const StatisticsTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'gpai' | 'dai'>('gpai');
  const [hovered, setHovered] = useState<'gpai' | 'dai' | null>(null);

  return (
    <div style={tabStyles.container}>
      <div style={tabStyles.navbar}>
        <button
          style={{
            ...tabStyles.button(activeTab === 'gpai'),
            ...(hovered === 'gpai' && !activeTab.includes('gpai')
              ? tabStyles.buttonHover
              : {}),
          }}
          onClick={() => setActiveTab('gpai')}
          onMouseEnter={() => setHovered('gpai')}
          onMouseLeave={() => setHovered(null)}
        >
          GPAI Statistics
        </button>
        <button
          style={{
            ...tabStyles.button(activeTab === 'dai'),
            ...(hovered === 'dai' && !activeTab.includes('dai')
              ? tabStyles.buttonHover
              : {}),
          }}
          onClick={() => setActiveTab('dai')}
          onMouseEnter={() => setHovered('dai')}
          onMouseLeave={() => setHovered(null)}
        >
          DAI Statistics
        </button>
      </div>
      <div style={tabStyles.content}>
        {activeTab === 'gpai' ? <GPAIStats /> : <DAIStats />}
      </div>
    </div>
  );
};

export default StatisticsTabs;
